import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

export const SidebarTableContent = ({
  sections,
  footer,
  rowClassName,
}: {
  sections: Array<Array<{ label: string | ReactNode; value: ReactNode }>>;
  footer?: { label: string; value: ReactNode };
  rowClassName?: string;
}) => {
  const hasSections = sections.length > 0;
  return (
    <div>
      {sections.map((items, index) => {
        return (
          <div
            key={index}
            className={cn('space-y-4', {
              'border-t border-gray-200 mt-3 pt-3': index > 0,
            })}
          >
            {items.map((item, itemIndex) => (
              <div
                key={`${index}-${itemIndex}`}
                className={cn('flex items-center justify-between gap-4', rowClassName)}
              >
                <span className="text-xs text-gray-500">{item.label}</span>
                <span className="text-end text-xs text-gray-900">{item.value}</span>
              </div>
            ))}
          </div>
        );
      })}
      {!!footer && (
        <div
          className={cn(
            { 'mt-5 border-t border-gray-200 pt-3': hasSections },
            '-mx-6 flex items-center justify-between gap-1 px-6',
          )}
        >
          <span className="text-xs text-gray-500">{footer.label}</span>
          <span className="text-end text-base font-bold text-gray-900 ">{footer.value}</span>
        </div>
      )}
    </div>
  );
};
